import { RouteRoleOptionFragment } from "gql/graphql";
import { SelectProps } from "@/shared/form/select";

export function useRouteRoleOptions(roles: RouteRoleOptionFragment[]): {
  options: NonNullable<SelectProps["options"]>;
} {
  const options = roles.map((role) => ({
    label: role.name.value ?? role.code,
    value: role.code,
    "data-testid": `route-role-option-${role.code}`,
  }));

  return { options };
}
